import React from 'react';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

interface UpdateNotificationBarProps {
  onUpdate: () => void;
}

export const UpdateNotificationBar = ({ onUpdate }: UpdateNotificationBarProps) => {
  const insets = useSafeAreaInsets();

  return (
    <View style={[styles.container, { paddingTop: insets.top }]}>
      <View style={styles.content}>
        <Text style={styles.text}>
          New version available. {' '}
          <Text 
            style={styles.link} 
            onPress={onUpdate}
          >
            Update now.
          </Text>
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#FFE5E5', // Light pink background
    width: '100%',
  },
  content: {
    paddingVertical: 10,
    paddingHorizontal: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    color: '#333',
    fontSize: 14,
    fontWeight: '500',
    textAlign: 'center',
  },
  link: {
    color: '#D32F2F', // Red text for the link
    textDecorationLine: 'underline',
    fontWeight: 'bold',
  },
});
